import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class SmallTitle extends React.PureComponent {
    state = {
        currentIndex: 4,
    };

    handleClick = e => {
        const dataIndex = e.target.getAttribute('data-index');

        this.setState({ currentIndex: dataIndex });
    };
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { title, anchors, rank } = this.props;
        const { currentIndex } = this.state;

        let withAnchors = null;

        if (rank) {
            withAnchors = (
                <ul>
                    <li>
                        <a
                            href={anchors[0]}
                            onClick={this.handleClick}
                            data-index="0"
                            className={styles[currentIndex === '0' ? 'current' : '']}>
                            A——F
                        </a>
                    </li>
                    <li>
                        <a
                            href={anchors[1]}
                            onClick={this.handleClick}
                            data-index="1"
                            className={styles[currentIndex === '1' ? 'current' : '']}>
                            G——L
                        </a>
                    </li>
                    <li>
                        <a
                            href={anchors[2]}
                            onClick={this.handleClick}
                            data-index="2"
                            className={styles[currentIndex === '2' ? 'current' : '']}>
                            M——T
                        </a>
                    </li>
                    <li>
                        <a
                            href={anchors[3]}
                            onClick={this.handleClick}
                            data-index="3"
                            className={currentIndex === '3' ? `${styles.current} ${styles.noR}` : styles.noR}>
                            U——Z
                        </a>
                    </li>
                </ul>
            );
        }

        return (
            <div className={styles.tit}>
                {title}
                {withAnchors}
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
SmallTitle.propTypes = { title: PropTypes.string, anchors: PropTypes.array, rank: PropTypes.bool };

/**
 * 定义组件默认属性
 * */
SmallTitle.defaultProps = {};

export default SmallTitle;
